import React, { useState } from 'react';
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import useOpenAccordion from 'src/components/store/useOpenAccordion';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import CustomPagination from 'src/components/pagination/CustomPaginatiion';

const page = 1;
const postPerPage = 0;
const pageSize = 20;
const urlApi = '/users';
const urlRouter = '/users';

const role = localStorage.getItem('user_role');
const userData = JSON.parse(localStorage.getItem('user_data'));

export async function LoaderUsers({ params }) {
  let query = `page=${page}`;
  if (role == 'ROLE_MANAGER')
    query += `&accounts.manager.id=${userData.id}`;

  let res = await AxiosInstance.get(`${urlApi}?${query}`).then((response) => {
    return response;
  });
  return res;
}

const roleList = {
  ROLE_ADMIN: 'Адміністратор',
  ROLE_MANAGER: 'Менеджер',
  ROLE_CLIENT: 'Клієнт',
  ROLE_USER: 'Без ролі',
};

const Users = ({ user_data }) => {
  if (!Permissions(user_data, 'User', 'VIEW_USER')) {
    return <PermissionsNoPage />;
  }
  const { data } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);
  const [usernameFilterSearch, setUsernameFilterSearch] = useState('');
  const [firstNameFilterSearch, setFirstNameFilterSearch] = useState('');
  const [lastNameFilterSearch, setLastNameFilterSearch] = useState('');
  // Заблокувати кнопку фільрації якщо не введені символи для пошуку
  const [disabled, setDisabled] = useState(true);



  // Відслідковувати стартове значення стану акордиону в залежності від розширення екрану
  const activeAccordionItem = useOpenAccordion();
  const activeItem = activeAccordionItem.activeItem;

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // Текст для popup
  const popupTextSuccess = "Користувача видалено";

  if (!rows) {
    setRowCountState(data['hydra:totalItems']);
    setRows(data['hydra:member']);
  };

  // Запит за попередніми замовленнями (+фільтр)
  const getRowsTable = (p = 1) => {
    let request = ``;
    if (usernameFilterSearch != '') {
      request += `&username=${usernameFilterSearch}`;
    };
    if (firstNameFilterSearch != '') {
      request += `&firstName=${firstNameFilterSearch}`;
    };
    if (lastNameFilterSearch != '') {
      request += `&lastName=${lastNameFilterSearch}`;
    };
    if (role == 'ROLE_MANAGER')
      request += `&accounts.manager.id=${userData.id}`;
    // console.log("request", request);
    AxiosInstance.get(`${urlApi}?page=${p}${request}`).then((response) => {
      setRows(response.data['hydra:member']);
      setRowCountState(response.data['hydra:totalItems']);
    });
  };

  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  };

  // Заблокувати кнопку фільтрації, якщо не введені символи для пошуку
  const disabledButton = event => {
    if (event.target.value) {
      setDisabled(false);
    } else {
      setDisabled(true);
    };
  };

  // Якщо хоч одне поле пошуку заповнене, то розблокувати кнопку пошуку
  useEffect(() => {
    if (usernameFilterSearch != "" || firstNameFilterSearch != "" || lastNameFilterSearch != "") {
      setDisabled(false);
    };
  }, [usernameFilterSearch, firstNameFilterSearch, lastNameFilterSearch]);


  // ----- Start handleFilterChange -----
  const handleUsernameFilterChange = event => {
    setUsernameFilterSearch(event.target.value);
    disabledButton(event);
  };

  const handleFirstNameFilterChange = event => {
    setFirstNameFilterSearch(event.target.value);
    disabledButton(event);
  };

  const handleLastNameFilterChange = event => {
    setLastNameFilterSearch(event.target.value);
    disabledButton(event);
  };
  // ----- End handleFilterChange -----

  // Фільтрування по userName, firstName та lastName
  const handleFilterSearch = () => {
    getRowsTable();
  };

  // Скинути фільтр
  const handleFilterReset = () => {
    setUsernameFilterSearch("");
    setFirstNameFilterSearch("");
    setLastNameFilterSearch("");
    setDisabled(true);
    getRowsTable();
  };

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = AxiosInstance.delete(urlApi + '/' + row.id, header).then((response) => {
              // Popup про успішні зміни
              popup.toastifySuccess(popupTextSuccess);
              getRowsTable();
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      disableColumnMenu: true,
      width: 50
    },
    {
      field: 'username',
      headerName: 'username',
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      renderCell: (params) => {
        return <Link to={`${urlRouter}/update/${params.row.id}`} style={{ textDecoration: "none", color: "rgba(0, 0, 0, 0.87)" }}>{params.row.username}</Link>;
      }
    },
    {
      field: 'firstName',
      headerName: 'Ім\'я',
      sortable: false,
      disableColumnMenu: true,
      width: 200
    },
    {
      field: 'lastName', headerName: 'Прізвище',
      sortable: false,
      disableColumnMenu: true,
      width: 200
    },
    {
      field: 'phone', headerName: 'Телефон',
      sortable: false,
      disableColumnMenu: true,
      width: 170
    },
    {
      field: "role",
      headerName: "Роль",
      sortable: false,

      sortable: false,
      disableColumnMenu: true,
      width: 130,
      renderCell: (params) => {
        let role = '';
        if (params.row.userRoles != undefined && typeof params.row.userRoles == 'object')
          role = params.row.userRoles.map((e) => {
            return e.role.label;
          });
        return role;
      }
    },
    // { field: 'address', headerName: 'Адреса', width: 200 },
    {
      field: 'status', headerName: 'Статус',
      sortable: false,
      disableColumnMenu: true,
      width: 120
    },
    // { field: 'codeUser', headerName: 'codeUser', width: 200 },
    {
      field: 'codeManager', headerName: 'codeManager',
      sortable: false,
      disableColumnMenu: true,
      width: 150
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      // renderCell: (params) => {
      //   return <Link to={`${urlRouter}/update/${params.row.id}`}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={`${urlRouter}/update/${params.row.id}`}><img src="/edit.svg" alt="edit" /></Link>;
      }

    },
    // {
    //   field: "delete",
    //   headerName: "Видалити",
    //   sortable: false,
    //   renderCell: (params) => {
    //     return <CButton color="danger" variant="outline" onClick={() => {
    //       Deleted(params.row)
    //     }
    //     }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
    //   }
    // },
  ];

  // Натиснення кнопки: "Enter" - виконати пошук; "Escape" - скинути пошук 
  const keyDown = (event) => {
    // Виконати пошук
    if (event.key === 'Enter' && !disabled) {
      event.preventDefault();
      handleFilterSearch(event);
    };
    // Скинути пошук
    if (event.key === 'Escape') {
      event.preventDefault();
      handleFilterReset(event);
    };
  };

  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4">
          <CAccordion key={activeItem} activeItemKey={activeItem} flush>
            <CAccordionItem itemKey={1}>
              <CAccordionHeader><strong>Фільтр</strong></CAccordionHeader>
              <CAccordionBody>
                <CRow className="my-3 mx-2">
                  <CCol md={9} className="me-auto">
                    <CRow>
                      <CCol md={4} className='filter-field info-col'>
                        <CFormInput
                          placeholder="username" id="usernameFilterSearch" aria-label="Пошук" className="me-2"
                          onChange={handleUsernameFilterChange} value={usernameFilterSearch} onKeyDown={keyDown} autoComplete="off"
                        />
                      </CCol>
                      <CCol md={4} className='filter-field info-col'>
                        <CFormInput
                          placeholder="Ім'я" id="firstNameFilterSearch" aria-label="Пошук" className="me-2"
                          onChange={handleFirstNameFilterChange} value={firstNameFilterSearch} onKeyDown={keyDown} autoComplete="off"
                        />
                      </CCol>
                      <CCol md={4} className='filter-field info-col'>
                        <CFormInput
                          placeholder="Прізвище" id="lastNameFilterSearch" aria-label="Пошук" className="me-2"
                          onChange={handleLastNameFilterChange} value={lastNameFilterSearch} onKeyDown={keyDown} autoComplete="off"
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol md={3} style={{ textAlign: "end", display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <CButton className="me-2 h-100" type="submit" color="secondary" onClick={handleFilterSearch} disabled={disabled}>Пошук</CButton>
                    <CButton style={{ height: '100%', width: '48px' }} type="submit" color="secondary" onClick={handleFilterReset}>X</CButton>
                  </CCol>
                </CRow>
              </CAccordionBody>
            </CAccordionItem>
            <div style={{ width: '100%', height: '0px', color: 'grey' }}></div>
          </CAccordion>

          <CCardHeader className='items_card_header'>
            {/* <strong> */}
            Користувачі
            {/* </strong>  */}
            <small></small>
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_solo'>
              <p className="text-medium-emphasis small">
                <Link to={`${urlRouter}/create`} className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                  {/* Створити */}
                  Add
                </CButton></Link>
              </p>
            </div>
            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}

                components={{ Pagination: CustomPagination }}
                headerHeight={44}

                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}

              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Users;